import React from 'react';
import ContactForm from '../ContactFrom';
import CalBooking from '../CalBooking';
import { trackEvent } from '../../analytics';

const Contactpage = () => {
  return (
    <>
      <section className="wpo-contact-pg-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-lg-10 offset-lg-1">
              <div className="contact-intro">
                <p className="contact-subtitle">
                  Agenda tu cita o contáctanos directamente. Al confirmar tu
                  reserva, serás redirigido al portal de pago seguro.
                </p>
              </div>
              <div className="office-info">
                <div className="row">
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-placeholder"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Dirección</h2>
                        <p style={{ textAlign: 'center' }}>
                          <a
                            href="https://www.google.com/maps/search/?api=1&query=H%26A%20Abogados%2C%20Av.%20Pedro%20de%20Valdivia%201210%2C%20Providencia"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => trackEvent('click_directions')}
                          >
                            Avenida Pedro de Valdivia 1210, Of. 404. Providencia.
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-email"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Email</h2>
                        <p style={{ textAlign: 'center' }}>
                          <a
                            href="mailto:contacto@estudiohya.cl"
                            onClick={() => trackEvent('click_email')}
                          >
                            Contacto@estudiohya.cl
                          </a>
                        </p>
                        <p style={{ textAlign: 'center' }}>
                          <a
                            href="mailto:info@estudiohya.cl"
                            onClick={() => trackEvent('click_email')}
                          >
                            Info@estudiohya.cl
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-phone-call"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>LLamanos</h2>
                        <p style={{ textAlign: 'center' }}>
                          <a
                            href="tel:+56232451291"
                            onClick={() => trackEvent('click_phone')}
                          >
                            +56 2 3245 1291
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cal.com Booking Section */}
      <CalBooking />

      {/* Contact Form Section */}
      <section className="wpo-contact-pg-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-lg-10 offset-lg-1">
              <div className="wpo-contact-title">
                <h2>
                  <div className="wpo-section-title">
                    <h2>Envíanos un Mensaje</h2>
                  </div>
                </h2>
              </div>
              <div className="wpo-contact-form-area">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wpo-contact-map-section">
        <div className="wpo-contact-map">
          <iframe
            title="Mapa de la Oficina H&A Abogados en Santiago"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.5885859890127!2d-70.61094678848804!3d-33.43396887328511!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf7748d8525b%3A0xf42ed127e81a9662!2sAv.%20Pedro%20de%20Valdivia%201210%2C%20oficina%20404%2C%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1754949738914!5m2!1ses-419!2scl"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>
    </>
  );
};

export default Contactpage;
